import { useEffect, useState } from 'react';
import { useAuth } from '../auth';
import { useI18n } from '../i18n';
import './SeasonCountdownBanner.css';

const API = import.meta.env.VITE_API_URL || 'http://localhost:8000';

interface Season {
  id: number;
  number: number;
  end_date: string;
}

export function SeasonCountdownBanner() {
  const { token } = useAuth();
  const { t } = useI18n();
  const [season, setSeason] = useState<Season | null>(null);

  useEffect(() => {
    let aborted = false;
    const url = token
      ? `${API}/stats/season/leaderboard?limit=1`
      : `${API}/stats/season/leaderboard/public?limit=1`;
    const headers: Record<string, string> = token ? { Authorization: `Bearer ${token}` } : {};
    fetch(url, { headers })
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (aborted || !data?.season) return;
        setSeason(data.season);
      })
      .catch(() => {});
    return () => { aborted = true; };
  }, [token]);

  if (!season) return null;
  const end = new Date(season.end_date);
  const now = new Date();
  const days = Math.max(0, Math.ceil((end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)));
  const sb = t.seasonBanner as any;
  const seasonLabel = sb.seasonLabel.replace('{n}', String(season.number));
  const daysLabel = days === 1 ? sb.dayLeft : sb.daysLeft.replace('{n}', String(days));
  const rewardLabel = sb.reward;

  return (
    <div className="season-banner">
      <span className="sb-icon">🏆</span>
      <div className="sb-text">
        <div className="sb-title">
          <strong>{seasonLabel}</strong>
          <span className="sb-days">{daysLabel}</span>
        </div>
        <div className="sb-reward">{rewardLabel}</div>
      </div>
    </div>
  );
}
